import { useState } from 'react';
import { useTranslations } from 'next-intl';

export const useCreateTabs = (values: string[], namespace: string) => {
  const [selectedTab, setSelectedTab] = useState(values[0]);

  const tr = useTranslations(namespace);

  const tabs = values.map((value: string) => ({
    value,
    label: tr.rich(`tabs.${value}.tab`),
  }));

  const setSelectedTabCallback = ({ value }: { value: string }) => setSelectedTab(value);

  return { tabs, selectedTab, setSelectedTab: setSelectedTabCallback };
};
